// Local translations
export const T = {
  en_GB: {
    ready: (name: string) => `"${name}" is ready`,
    failed: (name: string) => `"${name}" could not be made`,
    open: "Open",
    untranslatedKept: (count: number) =>
      count === 1
        ? "1 text could not be translated and stays in the original language."
        : `${count} texts could not be translated and stay in the original language.`,
  },
  nb_NO: {
    ready: (name: string) => `«${name}» er klar`,
    failed: (name: string) => `«${name}» kunne ikke lages`,
    open: "Åpne",
    untranslatedKept: (count: number) =>
      count === 1
        ? "1 tekst kunne ikke oversettes og står fortsatt på originalspråket."
        : `${count} tekster kunne ikke oversettes og står fortsatt på originalspråket.`,
  },
} as const;
